"use client";
import { FormGroup, FormError, Input, Label } from "cy-fe";
import { UseFormReturn } from "react-hook-form";

export interface ChangePasswordFormInputs {
  password: string;
  confirm: string;
  agree?: boolean;
}
export function ChangePassword({
  form,
}: {
  form: UseFormReturn<ChangePasswordFormInputs, any, ChangePasswordFormInputs>;
}) {
  return (
    <>
      <FormGroup controller={{ control: form.control, name: "password" }}>
        <Label>Enter Password</Label>
        <Input
          vSize="lg"
          type="password"
          {...form.register("password", {
            required: { value: true, message: "Required" },
            minLength: { value: 8, message: "Min Length 8" },
            deps: ["confirm"],
            pattern: {
              value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d]).+$/,
              message:
                "Must have upper/lower case character, number, and a non alphanumeric character",
            },
          })}
        />
        <FormError />
      </FormGroup>
      <FormGroup controller={{ control: form.control, name: "confirm" }}>
        <Label>Confirm Password</Label>
        <Input
          vSize="lg"
          type="password"
          {...form.register("confirm", {
            validate: {
              match: (val) => {
                if (val !== form.watch("password")) {
                  return "Passwords dont match";
                }
              },
            },
          })}
        />
        <FormError />
      </FormGroup>
    </>
  );
}
